module.exports = __webpack_public_path__ + "img/file_icon.662cd4fe.png";